export const config = {
  //dataset: process.env.NEXT_PUBLIC_SANITY_DATASET || "production",
  dataset: "staging", // for now we are using staging, TODO: figure out needs for envs for sanity across projs
  projectId: process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || "",
  apiVersion: "2022-03-02",
  useCdn: process.env.NODE_ENV === "production",
  perspective: "published",
};
